import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const VIEW_TABLES = 'view-tables'
export const VIEW_CHARTS = 'view-charts'
export const DOWNLOAD_TABLES = 'download-tables'
export const CHART_SETTINGS = 'chart-settings'

export default {
  [PORTUGUESE]: {
    [VIEW_TABLES]: 'Visualizar Tabelas',
    [VIEW_CHARTS]: 'Visualizar Gráficos',
    [DOWNLOAD_TABLES]: 'Baixar Tabelas',
    [CHART_SETTINGS]: 'Configurações do Gráfico',
  },

  [ENGLISH]: {
    [VIEW_TABLES]: 'View Tables',
    [VIEW_CHARTS]: 'View Charts',
    [DOWNLOAD_TABLES]: 'Download Tables',
    [CHART_SETTINGS]: 'Chart Settings',
  },

  [SPANISH]: {
    [VIEW_TABLES]: 'Ver Tablas',
    [VIEW_CHARTS]: 'Ver Gráficos',
    [DOWNLOAD_TABLES]: 'Descargar Tablas',
    [CHART_SETTINGS]: 'Configuración del Gráfico',
  },
}
